import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useIsMobile } from '../../hooks/useIsMobile';

interface ShareLinkProps {
  shareCode: string;
}

export default function ShareLink({ shareCode }: ShareLinkProps) {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const [copied, setCopied] = useState(false);

  const shareUrl = `${window.location.origin}/join/${shareCode}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(shareUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div style={{
      padding: '1.5rem',
      background: 'rgba(99, 102, 241, 0.1)',
      borderRadius: '16px',
      border: '1px solid rgba(99, 102, 241, 0.3)',
      marginBottom: '2rem',
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
        marginBottom: '1rem',
      }}>
        <span style={{ fontSize: '1.5rem' }}>🔗</span>
        <div>
          <h3 style={{ fontSize: '1.1rem', color: '#e2e8f0', margin: 0 }}>
            {t('shareLink.title')}
          </h3>
          <p style={{ fontSize: '0.85rem', color: '#a0aec0', margin: '0.25rem 0 0 0' }}>
            {t('shareLink.subtitle')}
          </p>
        </div>
      </div>

      <div style={{
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        alignItems: 'stretch',
        gap: '0.75rem',
      }}>
        <input
          type="text"
          value={shareUrl}
          readOnly
          style={{
            flex: 1,
            minWidth: 0, // let the field shrink so the button never gets pushed off-screen
            width: '100%',
            padding: '0.75rem 1rem',
            background: 'rgba(0, 0, 0, 0.3)',
            border: '1px solid rgba(99, 102, 241, 0.3)',
            borderRadius: '8px',
            color: '#cbd5e0',
            fontSize: '0.9rem',
            fontFamily: 'monospace',
            boxSizing: 'border-box',
          }}
          onClick={(e) => e.currentTarget.select()}
        />
        <button
          onClick={handleCopy}
          style={{
            padding: '0.75rem 1.5rem',
            flexShrink: 0,
            width: isMobile ? '100%' : 'auto',
            background: copied
              ? 'linear-gradient(135deg, #10b981 0%, #059669 100%)'
              : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            border: 'none',
            borderRadius: '8px',
            color: '#fff',
            fontWeight: 'bold',
            cursor: 'pointer',
            transition: 'all 0.3s',
            whiteSpace: 'nowrap',
          }}
          onMouseEnter={(e) => {
            if (!copied) {
              e.currentTarget.style.transform = 'scale(1.05)';
            }
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
          }}
        >
          {copied ? t('shareLink.copied') : t('shareLink.copy')}
        </button>
      </div>

      <div style={{
        marginTop: '1rem',
        padding: '0.75rem',
        background: 'rgba(16, 185, 129, 0.1)',
        borderRadius: '8px',
        border: '1px solid rgba(16, 185, 129, 0.2)',
      }}>
        <p style={{ fontSize: '0.85rem', color: '#a0aec0', margin: 0 }}>
          💡 <strong style={{ color: '#cbd5e0' }}>{t('shareLink.tipLabel')}</strong> {t('shareLink.tipText')}
        </p>
      </div>
    </div>
  );
}
